import { FC, ReactElement, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import CheckValidationRoute from "./CheckValidationRoute";
import useRoutes from "../../../commons/hooks/use-routes";
import CenterCircularProgress from "../../Spinner/CenterCircularProgress/CenterCircularProgress";

type CreateRoutesType = {
  inAuthenticatedRoute?: string;
  inAuthorizedRoute?: string;
  lazy?: boolean;
  loading?: ReactElement;
};

export type RouteType = {
  path?: string;
  pathSideBar?: string;
  exact?: boolean;
  title?: string;
  component?: any;
  permissions?: string[];
  inSecure?: boolean;
  sidebar?: boolean;
  iconTag?: any;
  icon?: any;
  routes?: RouteType[];
  onClick?: Function;
  onlyInMobile?: boolean;
  className?: string;
  href?: string;
  roles?: string[];
};

const checkRoute = (route: RouteType, results: RouteType[]) => {
  if (route.routes && route.routes.length) {
    generateFlatRoutes(route.routes, results);
  } else {
    results.push(route);
  }
};

const generateFlatRoutes = (routes: RouteType[], results: RouteType[]) => {
  routes.forEach((route) => {
    checkRoute(route, results);
  });
};

const CreateRoutes: FC<CreateRoutesType> = (props) => {
  const {
    inAuthenticatedRoute = "/auth/login",
    inAuthorizedRoute = "/access-denied",
    lazy = true,
    loading = <CenterCircularProgress />,
  } = props;

  let flatRoutes: RouteType[] = [];
  const { routes = [] } = useRoutes();
  generateFlatRoutes(routes, flatRoutes);

  const renderRoute = () => {
    return (
      <Switch>
        {flatRoutes.map((route: RouteType) => {
          if (route.path && route.component) {
            const renderComponent = (props: any) => (
              <CheckValidationRoute
                route={route}
                inAuthenticatedRoute={inAuthenticatedRoute}
                inAuthorizedRoute={inAuthorizedRoute}
              >
                <route.component {...props} />
              </CheckValidationRoute>
            );
            return <Route exact={route.exact} key={route.path} path={route.path} render={renderComponent} />;
          }
          return null;
        })}
      </Switch>
    );
  };

  if (lazy) {
    return <Suspense fallback={loading}>{renderRoute()}</Suspense>;
  } else {
    return renderRoute();
  }
};

export default CreateRoutes;
